import { useState } from "react";
import { Layout } from "@/components/layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { UploadInterface } from "@/components/internal-products/UploadInterface";
import { MetricsDashboard } from "@/components/internal-products/MetricsDashboard";
import { QueryGallery } from "@/components/internal-products/QueryGallery";
import { ReviewQueue } from "@/components/internal-products/ReviewQueue";

export default function InternalProductsPage() {
  const [activeTab, setActiveTab] = useState<string>("overview");

  return (
    <Layout headerContent={
      <div className="flex items-center gap-2 text-sm">
        <span className="text-muted-foreground">Internal</span>
        <span className="text-muted-foreground">/</span>
        <span className="font-semibold">Products</span>
      </div>
    }>
      <div className="container mx-auto py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">Product Master Pipeline</h1>
          <p className="text-muted-foreground mt-2">
            Internal tool for managing product data uploads, enrichment, and review
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList>
            <TabsTrigger value="overview">Overview & Upload</TabsTrigger>
            <TabsTrigger value="review">Review Queue</TabsTrigger>
          </TabsList>

          <TabsContent value="overview" className="space-y-6">
            {/* Upload Section */}
            <Card>
              <CardHeader>
                <CardTitle>Upload Files</CardTitle>
                <CardDescription>
                  Upload CSV files or spec sheets to the product master pipeline
                </CardDescription>
              </CardHeader>
              <CardContent>
                <UploadInterface />
              </CardContent>
            </Card>

            {/* Metrics Dashboard */}
            <MetricsDashboard />

            {/* Query Gallery */}
            <Card>
              <CardHeader>
                <CardTitle>Query Gallery</CardTitle>
                <CardDescription>
                  Run pre-built queries to explore pipeline data
                </CardDescription>
              </CardHeader>
              <CardContent>
                <QueryGallery />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="review" className="space-y-6">
            <ReviewQueue />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
